<template>
  <div>
    <el-container>
      <el-header height="15.8rem">
        <Header></Header>
        <!-- <div class="banner2"></div> -->
        <div class="navigation">
          <ul id="nav1">
            <li>
              <a @click="changeTab(0)" :class="currentTab == 0 ? 'active' : ''"
                >活动介绍</a
              >
            </li>
            <li>
              <a @click="changeTab(1)" :class="currentTab == 1 ? 'active' : ''">
                人才政策
              </a>
            </li>
            <li>
              <a @click="changeTab(2)" :class="currentTab == 2 ? 'active' : ''"
                >报名通道</a
              >
            </li>
            <li>
              <a @click="changeTab(3)" :class="currentTab == 3 ? 'active' : ''"
                >合作高校</a
              >
            </li>
            <li>
              <a @click="changeTab(4)" :class="currentTab == 4 ? 'active' : ''"
                >岗位信息</a
              >
            </li>
          </ul>
        </div>
      </el-header>
      <el-main>
        <!-- 活动介绍 -->
        <div v-show="currentTab == 0">
          <div class="row2" style="margin-bottom: 100px">
            <div class="imgc">嘉兴城市宣传片</div>
          </div>
          <div class="cardBox2">
            <div
              style="
                width: 550px;
                height: 308px;
                margin: 0 auto;
                margin-bottom: 50px;
              "
            >
              <div>
                <AliPlayer
                  ref="videoPlayer"
                  :source="src[0]"
                  height="308px"
                  :cover="cover"
                />
                <div
                  style="
                    text-align: center;
                    font-size: 0.36rem;
                    margin-top: 0.2rem;
                  "
                ></div>
              </div>
            </div>
            <div
              style="
                width: 550px;
                height: 308px;
                margin: 0 auto;
                margin-bottom: 50px;
              "
            >
              <div>
                <AliPlayer
                  ref="videoPlayer"
                  :source="src[1]"
                  height="308px"
                  :cover="cover2"
                />
                <div
                  style="
                    text-align: center;
                    font-size: 0.36rem;
                    margin-top: 0.2rem;
                  "
                ></div>
              </div>
            </div>
          </div>
          <div class="row2">
            <div class="imgc">活动介绍</div>
          </div>
          <div class="row">
            <div class="row2">
              <div class="imgt">
                <!-- <img src="@/assets/hdjs/left.png" alt="标题左" /> -->
                <span>活动背景</span>
                <!-- <img src="@/assets/hdjs/right.png" alt="标题右" /> -->
              </div>
            </div>
            <p>
              为深入实施人才强市战略，加强与我市产业需求契合度高的国内院校之间的人才交流与合作，精准引进我市急缺的各类专业人才，努力把我市建设成长三角金南翼最具创新活力的产才融合典范市、青创人才理想城、营智环境标杆地。  
            </p>
            <div class="row2">
              <div class="imgt">
                <!-- <img src="@/assets/hdjs/left.png" alt="标题左" /> -->
                <span>时间地点</span>
                <!-- <img src="@/assets/hdjs/right.png" alt="标题右" /> -->
              </div>
            </div>
            <p>
              时间：2022年8月3-5日（周三、周四、周五）
            </p>
            <p>
              地点：嘉兴龙之梦酒店（嘉兴市中环南路1977号）
            </p>
            <div class="row2">
              <div class="imgt">
                <!-- <img src="@/assets/hdjs/left.png" alt="标题左" /> -->
                <span>组织形式</span>
                <!-- <img src="@/assets/hdjs/right.png" alt="标题右" /> -->
              </div>
            </div>
            <p>本次活动由中共嘉兴市委人才工作领导小组办公室、嘉兴市人力资源和社会保障局主办，各县（市、区）委人才工作领导小组办公室、各县（市、区）人力资源和社会保障局承办。</p>
            <div class="row2">
              <div class="imgt">
                <span>活动规模</span>
              </div>
            </div>
            <div>
              <p>线上：用人单位500家以上、全国各大高校、职业院所300家左右。</p>
              <p>线下：用人单位100家以上、全国各类高校、职业院所、技师学校等100家左右。</p>
            </div>
            <div class="row2">
              <div class="imgt">
                <span>参加对象</span>
              </div>
            </div>
            <div>
              <p>1.全国知名院校100家左右；</p>
              <p>2.嘉兴上市公司、高新技术企业、规上企业、领军人才企业以及高校、科研院所等单位100家左右，由各县（市、区）人社局组织用人单位参加线下对接活动。待工作人员审核，收到邀请短信方能参会。</p>
            </div>
            <div class="row2">
              <div class="imgt">
                <span>活动安排</span>
              </div>
            </div>
            <div class="tableWidth">
              <table style="border-collapse: collapse; width: 97%;margin-left: auto;
                margin-right: auto;" border="1">
                <tbody>
                <tr>
                <td style="text-align: center; width: 36.3819%;">
                <p>时 间</p>
                </td>
                <td style="text-align: center; width: 32%;">
                <p>内 容</p>
                </td>
                <td style="text-align: center; width: 148.687%;">
                <p>地 点</p>
                </td>
                </tr>
                <tr>
                <td style="text-align: center; width: 36.3819%;">
                <p>3日（周三）</p>
                <p>14:00-20:00</p>
                </td>
                <td style="text-align: center; width: 31.7394%;">
                <p>参会高校报到</p>
                </td>
                <td style="text-align: center; width: 148.687%;">
                <p>嘉兴龙之梦大酒店</p>
                <p>（嘉兴市南湖区中环东路1977号）</p>
                </td>
                </tr>
                <tr>
                <td style="text-align: center; width: 36.3819%;">
                <p>4日（周四）</p>
                <p>上午9:00-10:00</p>
                </td>
                <td style="text-align: center; width: 31.7394%;">
                <p>百所高校&ldquo;嘉兴行&rdquo;活动启动仪式</p>
                </td>
                <td style="text-align: center; width: 148.687%;">
                <p>嘉兴龙之梦大酒店</p>
                </td>
                </tr>
                <tr>
                <td style="text-align: center; width: 36.3819%;">
                <p>4日（周四）</p>
                <p>上午10:00-12:00</p>
                </td>
                <td style="text-align: center; width: 31.7394%;">
                <p>校企合作洽谈会</p>
                </td>
                <td style="text-align: center; width: 148.687%;">
                <p>嘉兴龙之梦大酒店</p>
                </td>
                </tr>
                <tr>
                <td style="text-align: center; width: 36.3819%;">
                <p>4日（周四）</p>
                <p>下午14:00-17:00</p>
                </td>
                <td style="text-align: center; width: 31.7394%;">
                <p>校地、校企人才合作</p>
                <p>对接座谈会</p>
                </td>
                <td style="text-align: center; width: 148.687%;">
                <p>嘉兴龙之梦大酒店</p>
                </td>
                </tr>
                <tr>
                <td style="text-align: center; width: 36.3819%;">
                <p>5日（周五）</p>
                <p>上午9:00-11:30</p>
                </td>
                <td style="text-align: center; width: 31.7394%;">
                <p>各县（市、区）与高校对接</p>
                </td>
                <td style="text-align: center; width: 148.687%;">
                <p>嘉兴各县（市、区）</p>
                </td>
                </tr>
                <tr>
                <td style="text-align: center; width: 36.3819%;">
                <p>5日（周五）</p>
                <p>下午</p>
                </td>
                <td style="text-align: center; width: 31.7394%;">
                <p>活动结束返程</p>
                </td>
                <td style="text-align: center; width: 148.687%;">&nbsp;</td>
                </tr>
                </tbody>
                </table>
            </div>
            <!-- <div class="row2">
              <div class="imgt">
                <span
                  >媒体宣传</span>
              </div>
            </div>
            <div>
              <p style="line-height: 29pt; margin: 0pt 0pt 0.0001pt; text-align: justify; font-size: 10.5pt;"><span style="font-size: 18px;">1.邀请中国组织人事报、浙江日报、嘉兴日报、南湖晚报、嘉兴电视台、读嘉、禾点点、凤凰网、新浪网等各大媒体进行宣传报道，发布宣传海报。</span></p>
              <p style="line-height: 29pt; margin: 0pt 0pt 0.0001pt; text-align: justify; font-size: 10.5pt;"><span style="font-size: 18px;">2.在市人力社保局网站、嘉兴人事人才网设立专栏，发布招聘单位需求信息。</span></p>
              <p style="line-height: 29pt; margin: 0pt 0pt 0.0001pt; text-align: justify; font-size: 10.5pt;"><span style="font-size: 18px;">3.在嘉大中专院校就业信息网发布活动信息。</span></p>
              <p style="line-height: 29pt; margin: 0pt 0pt 0.0001pt; text-align: justify; font-size: 10.5pt;"><span style="font-size: 18px;">4.在报纸、电视、微信、APP等渠道发布活动信息。</span></p>
              <p style="line-height: 29pt; margin: 0pt 0pt 0.0001pt; text-align: justify; font-size: 10.5pt;"><span style="font-size: 18px;">5.在街道社区平台发布活动信息。</span></p>
            </div>
            <div class="row2">
              <div class="imgt">
                <span
                  >疫情防控</span>
              </div>
            </div>
            <p>
              各项活动根据疫情防控要求，成立疫情防控专项小组，按照“一活动一方案”要求，制定疫情防控方案，严格做好防疫工作。
            </p>
            <p>
              参会人员需提供健康码绿码、48小时内核酸阴性报告、行程码不带*，同时做好个人防护，自觉遵守防疫管控规定。
            </p> -->
          </div>
        </div>
        <!-- 人才政策 -->
        <div v-if="currentTab == 1">
          <div class="row2">
            <div class="imgc">嘉兴人才政策</div>
          </div>
          <div class="row">
            <p style="font-weight: bold">
              为深入实施新时代人才强市战略，全方位培养、引进、用好人才，推动打造世界重要人才中心和创新高地的战略节点，努力建设长三角金南翼最具创新活力的产才融合典范市、青创人才理想城、营智环境标杆地，加快建设共同富裕典范城市和社会主义现代化先行市，嘉兴先后推出了一系列人才引进政策，现将人才政策节选如下：
            </p>
          </div>
          <div class="tableWidth">
            <table
              style="
                border-collapse: collapse;
                width: 96.1682%;
                margin-left: auto;
                margin-right: auto;
                height: 1449px;
              "
              border="1"
            >
              <tbody>
                <tr style="height: 60px">
                  <td style="width: 11.3809%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"><strong>类别</strong></span>
                    </p>
                  </td>
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"><strong>内容</strong></span>
                    </p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        ><strong>政策奖励</strong></span
                      >
                    </p>
                  </td>
                  <td style="width: 16.1048%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        ><strong>联系方式</strong></span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td
                    style="width: 11.3809%; text-align: center; height: 120px"
                    rowspan="2"
                  >
                    <p>
                      <span style="font-size: 18px"
                        >博士后（博士政策均可享受）</span
                      >
                    </p>
                  </td>
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">进站科研生活补贴</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >25-35万元/年科研生活补助，资助期2年。</span
                      >
                    </p>
                  </td>
                  <td
                    style="width: 16.1048%; text-align: center; height: 120px"
                    rowspan="2"
                  >
                    <p><span style="font-size: 18px">市人力社保局</span></p>
                    <p><span style="font-size: 18px">82228976</span></p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >出站留嘉（来嘉）生活补助</span
                      >
                    </p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">最高20万元</span></p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td
                    style="width: 11.3809%; text-align: center; height: 360px"
                    rowspan="6"
                  >
                    <p><span style="font-size: 18px">博士</span></p>
                  </td>
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px">购房补贴（人才房票）</span>
                    </p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">45万元</span></p>
                  </td>
                  <td
                    style="width: 16.1048%; text-align: center; height: 1020px"
                    rowspan="17"
                  >
                    <p><span style="font-size: 18px">市人力社保局</span></p>
                    <p><span style="font-size: 18px">83837062</span></p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">企业人员生活补贴</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">6万元</span></p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px">企业人员工资外津贴</span>
                    </p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px">1000元/月，最长3年。</span>
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">挂职兼职补贴</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >市外高校、科研院所博士到机关事业单位挂兼职，给予3000元/月补贴，最长2年。</span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >企业在职人员攻读博士奖励</span
                      >
                    </p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">5万元</span></p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">住房公积金贷款</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >60万元住房公积金贷款额度</span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td
                    style="width: 11.3809%; text-align: center; height: 360px"
                    rowspan="6"
                  >
                    <p><span style="font-size: 18px">硕士</span></p>
                  </td>
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px">购房补贴（人才房票）</span>
                    </p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">23万元</span></p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">企业生活补贴</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">3万元</span></p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px">企业人员工资外津贴</span>
                    </p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px">600元/月，最长3年。</span>
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">挂职兼职补贴</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >市外高校、科研院所硕士到机关事业单位挂职兼职
                        的给予2000元/月补贴，最长2年</span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >企业在职人员攻读硕士奖励</span
                      >
                    </p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">3万元</span></p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">住房公积金贷款</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >60万元住房公积金贷款额度</span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td
                    style="width: 11.3809%; text-align: center; height: 180px"
                    rowspan="3"
                  >
                    <p><span style="font-size: 18px">本科</span></p>
                  </td>
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">企业人员购房补贴</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >毕业5年内重点高校全日制本科毕业生15万元；
                        毕业5年内普通高校全日制本科毕业生8万元。</span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">企业人员生活补贴</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >重点高校全日制应届本科毕业生2万元；普通高校全日制应届本科毕业生1万元。</span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">住房公积金贷款</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >45万元住房公积金贷款额度</span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td
                    style="width: 11.3809%; text-align: center; height: 120px"
                    rowspan="2"
                  >
                    <p><span style="font-size: 18px">专科</span></p>
                  </td>
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">企业人员生活补贴</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >高校全日制应届专科毕业生6000元</span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 60px">
                  <td style="width: 13.6191%; text-align: center; height: 60px">
                    <p><span style="font-size: 18px">住房公积金贷款</span></p>
                  </td>
                  <td style="width: 56.1682%; text-align: center; height: 60px">
                    <p>
                      <span style="font-size: 18px"
                        >30万元住房公积金贷款额度</span
                      >
                    </p>
                  </td>
                </tr>
                <tr style="height: 146px">
                  <td
                    style="width: 11.3809%; text-align: center; height: 146px"
                  >
                    <p><span style="font-size: 18px">专业</span></p>
                    <p><span style="font-size: 18px">技术</span></p>
                    <p><span style="font-size: 18px">人才</span></p>
                  </td>
                  <td
                    style="width: 13.6191%; text-align: center; height: 146px"
                  >
                    <p>
                      <span style="font-size: 18px">企业人员职称提升奖励</span>
                    </p>
                  </td>
                  <td
                    style="width: 56.1682%; text-align: center; height: 146px"
                  >
                    <p>
                      <span style="font-size: 18px"
                        >企业人员新取得正高级专业技术资格，给予10000元奖励；企业人员新取得副高级专业技术资格，给予5000元奖励</span
                      >
                    </p>
                  </td>
                  <td
                    style="width: 16.1048%; text-align: center; height: 146px"
                  >
                    <p><span style="font-size: 18px">市人力社保局</span></p>
                    <p><span style="font-size: 18px">82228975</span></p>
                  </td>
                </tr>
                <tr style="height: 103px">
                  <td
                    style="width: 11.3809%; text-align: center; height: 103px"
                  >
                    <p><span style="font-size: 18px">技能</span></p>
                    <p><span style="font-size: 18px">人才</span></p>
                  </td>
                  <td
                    style="width: 13.6191%; text-align: center; height: 103px"
                  >
                    <p>
                      <span style="font-size: 18px"
                        >企业人员职业资格培训补贴</span
                      >
                    </p>
                  </td>
                  <td
                    style="width: 56.1682%; text-align: center; height: 103px"
                  >
                    <p>
                      <span style="font-size: 18px"
                        >符合补贴条件的劳动者，取得国家职业资格证书（职业技能等级证书），分别给予初级工、中级工、高级工、技师、高级技师不低于800、1200、1800、2500、3200元的培训补贴。</span
                      >
                    </p>
                  </td>
                  <td
                    style="width: 16.1048%; text-align: center; height: 103px"
                  >
                    <p><span style="font-size: 18px">市人力社保局</span></p>
                    <p><span style="font-size: 18px">82228816</span></p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

            <div class="row2">
            <div class="imgc">嘉兴概况</div>
          </div>
          <div class="row">
            <div>
            <p>
              嘉兴地处浙江省东北部，东接上海，北邻苏州，西连杭州，南濒杭州湾，陆域面积4223平方公里，海域面积1523平方公里，常住人口541万，下辖南湖、秀洲2个区，平湖、海宁、桐乡3个县级市和嘉善、海盐2个县。2021年，全市生产总值6355.28亿元（居全省第5位），财政总收入和一般公共预算收入分别达到1122.77亿元和674.8亿元（均居全省第3位），城乡居民人均可支配收入分别达到6.98万元、4.36万元，农民收入连续18年居浙江省首位。在最新的城市排名中，嘉兴综合实力列全国百强城市35位，经济总量列41位，财政综合实力列全国20位、地级市第5位。2021中国城市“95后”人才吸引力50强榜单，嘉兴位列全国第25位、浙江省内第三。</p>
              <p>嘉兴是中国革命红船的起航地。1921年7月，中国共产党第一次代表大会在嘉兴南湖举行，通过了党的第一个纲领和第一个决议，选举产生了中央局，标志着中国共产党正式成立，中国革命的航船从此扬帆启航。“红船”见证了中国历史上开天辟地的大事变，成为中国革命源头的象征。</p>
            <p> 嘉兴是马家浜文化的发祥地。境内马家浜文化遗址距今已有7000多年，是长江下游、太湖流域新石器时代早期文化的代表。春秋战国时期嘉兴为吴越争战之地，有吴根越角之称。近现代涌现出王国维、徐志摩、茅盾、丰子恺、陈省身、金庸等名师大家，嘉兴的“两院”院士达到51名。</p>
              <p>嘉兴是接轨上海融入长三角的前沿阵地。嘉兴积极抢抓地处“一带一路”“长江经济带”“长三角区域一体化发展”三大国家战略交汇点的重大发展机遇，不断提升在基础设施、科技创新、产业平台、公共服务、生态建设等方面的对接水平。</p>
              <p>嘉兴是推进城乡一体化的先行之地。创新实施统筹城乡综合配套改革，扎实开展国家“多规合一”和新型城镇化试点。实现城乡居民医疗保险并轨和最低生活保障标准城乡统一，打响了图书馆总分馆、农村文化礼堂的“嘉兴品牌”，城乡居民收入差距全省最小，统筹城乡发展水平居全省第一。</p>
              <p>今后五年嘉兴将坚持以习近平新时代中国特色社会主义思想为指导，全面落实习近平总书记考察浙江、嘉兴重要讲话精神和中央、省委决策部署，忠诚拥护“两个确立”、坚决做到“两个维护”，深入践行以人民为中心的发展思想，立足新发展阶段、贯彻新发展理念、服务新发展格局，大力弘扬伟大建党精神和红船精神，坚决守好红色根脉，忠实践行“八八战略”，深度融入和推进长三角一体化发展，持续擦亮“七张金名片”，全力推动嘉兴蝶变跃升、跨越发展，奋力实现“两个率先”，加快建设共同富裕典范城市和社会主义现代化先行市，努力成为“重要窗口”中最精彩板块，全面谱写奋进第二个百年目标的崭新篇章。</p>
              <p>城以才兴，市以才强。生机勃勃的嘉兴，正在成为青年人创业创新的活力之城。我们以最好的政策、最优的服务、最全的保障支持，热忱欢迎海内外精英人才来嘉兴就业创业，成为嘉兴城市发展的合伙人和见证者。</p>
            </div>
          </div>

        </div>
        <!-- 引才单位风采 -->
        <div v-show="currentTab == 2">
          <div class="row2" style="padding-bottom: 2rem">
            <!-- <div class="imgc">高校报名通道</div> -->
          </div>
          <div class="cardBox">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-weight: 700; font-size: 20px"
                  >高校报名通道</span
                >
                <el-button style="float: right; padding: 3px 0" type="text" @click="toSignUp('http://zhaopin.yrdtalent.com/School/Login')">前往报名</el-button>
              </div>
              <div class="text item">
                <p>请用pc端报名，填报高校相关信息。</p>
              </div>
            </el-card>
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-weight: 700; font-size: 20px"
                  >实践岗位征集通道</span
                >
                <el-button
                  style="float: right; padding: 3px 0"
                  type="text"
                  @click="toSignUp('https://dlo.jxrsrc.com/xczph/fair/index_new.aspx?id=235')"
                  >前往报名</el-button
                >
              </div>
              <div class="text item">
                <p>本次征集用于下半年外出校招</p>
              </div>
            </el-card>
          </div>
          <!-- <div class="row2" style="padding-bottom: 2rem">
            <div class="imgc">参会单位报名通道</div>
          </div>
          <div class="cardBox4">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span style="font-weight: 700; font-size: 20px"
                  >参会单位报名通道</span
                >
                <el-button style="float: right; padding: 3px 0" type="text" @click="toSignUp('http://zhaopin.yrdtalent.com/School/Login')">前往报名</el-button>
              </div>
              <div class="text item">
                <p>参会单位需先填报岗位，待高校报名结束后，根据岗位需求和高校对接的单位再报名，报名后等待工作人员审核，收到邀请短信才能进入会场。</p>
              </div>
            </el-card>
          </div> -->
          <!-- <div class="row2" style="padding-bottom: 2rem">
            <div class="imgc">学生岗位投递通道</div>
          </div>
          <div class="cardBox3">
            <el-card class="box-card3">
              <div slot="header" class="clearfix">
                <span style="font-weight: 700; font-size: 20px"
                  >学生岗位投递通道</span
                >
              </div>
              <div class="text2 item" style="text-align: center">
                <img src="@/assets/qrcode.png" alt="" style="width: 30%" />
                <p>扫码注册报名，投递简历后，经会务组审核通过参会。</p>
              </div>
            </el-card>
          </div> -->
        </div>
        <div
          v-loading.fullscreen.lock="loading"
          element-loading-text="拼命加载中"
        ></div>
        <div v-if="currentTab == 3">
          <div class="main2">

            <div class="section web">
              <div class="row2">
                <div class="imgc">参会高校</div>
              </div>
              <div class="list2">
                <ul
                  class="
                    width:
                    100%;
                    text-align:
                    center;
                    clear:
                    both;
                    padding:
                    30px
                    20px;
                    text-align:
                    left;
                    margin:
                    0
                    auto;
                    line-height:
                    18px;
                  "
                >
                  <div class="box-wrap">
                    <li v-for="(item, index) in dataSet" :key="index">
                      <div class="sch_logo">
                        <el-image :src="item.logo" alt="" lazy>
                          <div slot="placeholder" class="image-slot">
                            加载中<span class="dot">...</span>
                          </div>
                        </el-image>
                      </div>
                      <div class="firm">
                        <a
                          @click="test0(item.Id)"
                        >
                          <p>
                            <b>{{ item.title }}</b>
                          </p>
                        </a>
                      </div>
                      <!-- <div class="jobs2">
                          {{ item.content }}
                      </div> -->
                      <div class="btns">
                        <a
                          @click="test0(item.Id)"
                        >
                          查看更多
                        </a>
                      </div>
                    </li>
                  </div>
                </ul>
              </div>
            </div>

            <div class="section web">
              <div class="row2">
                <div class="imgc">高校云聘会</div>
              </div>
              <div class="list2">
                <ul
                  class="
                    width:
                    100%;
                    text-align:
                    center;
                    clear:
                    both;
                    padding:
                    30px
                    20px;
                    text-align:
                    left;
                    margin:
                    0
                    auto;
                    line-height:
                    18px;
                  "
                >
                  <div class="box-wrap">
                    <li v-for="(item0, index0) in gulDataSet" :key="index0">
                      <div class="sch_logo">
                        <el-image :src='"http://dlo.jxrsrc.com/zph2022/20220322/"+item0.logourl' alt="" lazy>
                          <div slot="placeholder" class="image-slot">
                            加载中<span class="dot">...</span>
                          </div>
                        </el-image>
                      </div>
                      <div class="firm">
                        <a
                          :href="item0.homelink"
                          target="_blank"
                        >
                          <p>
                            <b>{{ item0.uniname }}</b>
                            <span v-if="item0.holdtime">举办时间：{{item0.holdtime}}</span>
                          </p>
                        </a>
                      </div>
                      <!-- <div class="jobs2">
                          {{ item.content }}
                      </div> -->
                      <div class="btns">
                        <a
                          :href="item0.homelink"
                          target="_blank"
                        >
                          查看更多
                        </a>
                      </div>
                    </li>
                  </div>
                </ul>
              </div>
            </div>

          </div>
        </div>
        <div v-if="currentTab == 4">
          <div class="main2">
            <div class="section web">
              <div class="list2">
                <ul
                  class="
                    width:
                    100%;
                    text-align:
                    center;
                    clear:
                    both;
                    padding:
                    30px
                    20px;
                    text-align:
                    left;
                    margin:
                    0
                    auto;
                    line-height:
                    18px;
                  "
                >
                  <!-- <div class="line2" style="display: block">
                      <span>2022年嘉兴市夏季人才交流大会暨高校毕业生就业实习专场云聘会</span>
                    </div> -->
                  <div class="box-wrap">
                    <li v-for="(item2, index2) in olDataSet" :key="index2">
                      <div class="firm">
                        <a
                          :href="
                            'https://dlo.jxrsrc.com/xczp/ExportWordPre.aspx?RecID=' +
                            item2.recid +
                            '&' +
                            'id=' +
                            item2.id
                          "
                          target="_blank"
                        >
                          <p>
                            <b>{{ item2.cmpName }}</b>
                            <!-- <span>国有企业</span> -->
                          </p>
                        </a>
                      </div>
                      <div class="jobs">
                        <a
                          :href="
                            'https://dlo.jxrsrc.com/xczp/ExportWordPre.aspx?RecID=' +
                            item2.recid +
                            '&' +
                            'id=' +
                            item2.id
                          "
                          target="_blank"
                          v-for="(item3, index3) in item2.jobs.slice(0, 3)"
                          :key="index3"
                        >
                          <span>{{ item3.JobName }}</span>
                        </a>
                      </div>
                      <div class="btns">
                        <a
                          :href="
                            'https://dlo.jxrsrc.com/xczp/ExportWordPre.aspx?RecID=' +
                            item2.recid +
                            '&' +
                            'id=' +
                            item2.id
                          "
                          target="_blank"
                        >
                          查看更多职位
                        </a>
                      </div>
                    </li>
                  </div>
                  <!-- </div> -->
                </ul>
              </div>
            </div>
          </div>
        </div>
      </el-main>
      <el-footer>
        <div class="foot">
          <div style="margin-top: 100px">
            <p>
              嘉兴东方人才服务公司 版权所有Copyright © 1999-2022 CNCHR. All
              rights reserved.
            </p>
            <p>网站备案:浙ICP备14023938号-1</p>
            <p>公网安备:浙公网安备 33040202000321号</p>
          </div>
        </div>
      </el-footer>
    </el-container>
  </div>
</template> 


<script>
/* eslint-disable */
import Vue from "vue";
// import VueVideoPlayer from "vue-video-player";
// import "video.js/dist/video-js.css";
// import "videojs-contrib-hls";
import cover from "@/assets/hdjs/cover.jpg";
import cover2 from "@/assets/hdjs/cover2.jpg";
import back1 from "@/assets/back1.jpg";
import back3 from "@/assets/back3.jpg";
import AliPlayer from "../component/AliPlayer.vue";
import Header from "../component/header.vue";
import { selfRequest_idx } from "@/api/discoverydata";
import { selfRequest_gul } from "@/api/discoverydata";
import { selfRequest224 } from "@/api/discoverydata";
import { selfRequest235 } from "@/api/discoverydata";
import "@/icons/iconfont.js";
import jxcs from "@/assets/hdjs/jxcs.mp4";
import jyk from "@/assets/hdjs/jyk.mp4";
// Vue.use(
//   VueVideoPlayer
// );
// Vue.use(Lazyload, {
//   loading: zhanwei,
// });

export default {
  name: "PcIndex",
  components: { AliPlayer,Header },
  data() {
    return {
      cover,
      cover2,
      back3,
      back1,
      currentTab: 0,
      src: [jxcs, jyk],
      jobData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      dataSet: [],
      gulDataSet:[],
      flag: false,
      loading: false,
      loadedTab3: false,
      loadedTab4: false,
      clickTab3: false,
      clickTab4: false,
      olDataSet: [],
    };
  },
  watch: {
    loadedTab3: function () {
      this.$nextTick(function () {
        if (this.clickTab3) {
          this.loading = false;
          this.currentTab = 3;
        }
      });
    },
    loadedTab4: function () {
      this.$nextTick(function () {
        if (this.clickTab4) {
          this.loading = false;
          this.currentTab = 4;
        }
      });
    }
  },
  created() {},
  mounted() {
    selfRequest_gul({}).then((res) => {
      console.log(res);
      this.gulDataSet = res
    });
    // 专场信息
    selfRequest_idx({}).then((res) => {
      console.log(res);
      var tampArr = []
      tampArr = res.data
      tampArr.reverse()
      var tempArr2 = []
      var tempArr3 = []
      for(let i = 0;i<tampArr.length;i++){
        if(tampArr[i].type == '双一流'){
          tempArr2.push(tampArr[i])
        }
        else{
          tempArr3.push(tampArr[i])
        }
      }
      tampArr = tempArr2.concat(tempArr3)
      this.dataSet = tampArr
      this.loadedTab3 = true;
    });
    // 线上信息
    selfRequest235({}).then((res) => {
      var tempArr = [];
      tempArr = res.cmps;
      selfRequest224({}).then((res2) => {
        tempArr = tempArr.concat(res2.cmps);
        this.olDataSet = tempArr;
        this.loadedTab4 = true;
       });
    });
  },
  computed: {},
  beforeDestroy() {
    // if (this.player) {
    //   this.player.dispose();
    // }
  },
  methods: {
    test0(id){
      // console.log(id);
      let routeOne = this.$router.resolve({
        path: '/detail/'+id,
        // query: {
        //     id:id
        // }
     });
    window.open(routeOne.href, '_blank');
    },
    toSignUp(n) {
        window.open(n,'_blank')
    },
    changeTab(i) {
      if (i === 3) {
        this.clickTab3 = true;
        if (!this.loadedTab3) {
          this.loading = true;
        } else {
          this.currentTab = i;
        }
      } 
      else if (i === 4){
        this.clickTab4 = true;
        if (!this.loadedTab4) {
          this.loading = true;
        } else {
          this.currentTab = i;
        }
      }
      else {
        this.currentTab = i;
      }
    },
  },
};
</script>
<style>
.container {
  width: 100%;
  background: #f4f4f4;
}
.container {
  width: 100%;
  background: #f4f4f4;
}
.navigation {
  text-align: center;
  color: #000;
}
ul#nav1 {
  width: 100%;
  height: 80px;
  background: #fff;
  margin: 0 auto;
}
ol,
ul {
  list-style: none;
}
ul#nav1 li {
  margin: 0 -3px;
  display: inline;
  height: 80px;
}
ul#nav1 li a {
  display: inline-block;
  padding: 0 130px;
  height: 80px;
  line-height: 80px;
  color: #3fcfea;
  font-family: "\5FAE\8F6F\96C5\9ED1";
  font-size: 30px;
  text-decoration: none;
  font-weight: 700;
  cursor: pointer;
}
.navigation ul#nav1 li a.active,
.navigation ul#nav1 li a:hover {
  color: #fff;
  background: #3fcfea;
}

.row {
  width: 100%;
  max-width: 1200px;
  min-width: 755px;
  margin: 0 auto;
  overflow: hidden;
  text-align: left;
}
.row2 {
  max-width: 1260px;
  min-width: 755px;
  margin: 0 auto;
  /* overflow: hidden; */
  text-align: center;
}
.row2 .imgt {
  margin: 1rem 0;
  font-size: 30px;
}
.row2 .imgt img {
  margin-bottom: -10px;
}
.row2 .imgt span {
  color: #000;
  font-weight: 700;
}
.row2 .imgc {
  margin: 0 auto;
  width: 400px;
  height: 114px;
  background: url(../../assets/hdjs/101b2ff9.png) no-repeat 50%;
  text-align: center;
  font-family: Courier New, Courier, monospace;
  font-size: 30px;
  font-weight: 700;
  line-height: 58px;
  color: #fff;
  padding-top: 30px;
  margin-top: 80px;
  margin-bottom: 30px;
}
.row2 .video {
  max-width: 960px;
  min-width: 395px;
  margin: 0 auto;
  padding-top: 22px;
  padding-bottom: 120px;
}
.row p {
  line-height: 40px;
  padding: 0 30px;
  text-indent: 40px;
  font-size: 18px;
  font-family: Microsoft YaHei !important;
  color: #000;
}
.tableWidth p{
  text-indent: 0px;
}
.videoBox {
  display: grid;
  grid-template-columns: repeat(3, 350px);
  grid-template-rows: repeat(6, 250px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 120px;
}
.videoBox .video {
  max-width: 350px;
  margin: 0 auto;
  padding-top: 22px;
  /* padding-bottom: 120px; */
  /* padding-bottom: 50px; */
}
.wrap-4-wrap {
  /* margin: 0 0 .1rem; */
  width: 1200px;
  margin: 0 auto;
  margin-top: 50px;
}
.el-tabs--border-card {
  background: #fff;
  border: 1px solid #dcdfe6;
  -webkit-box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12),
    0 0 6px 0 rgba(0, 0, 0, 0.04);
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12), 0 0 6px 0 rgba(0, 0, 0, 0.04);
  /* height: 838px; */
}
.el-tabs--border-card > .el-tabs__content {
  padding: 15px;
}
.el-tabs__content {
  overflow: hidden;
  position: relative;
}
.wrap-4-wrap .el-tab-pane {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: distribute;
  justify-content: space-between;
}
.wrap-4-wrap .el-tab-pane {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -ms-flex-pack: distribute;
}
.wrap-4-wrap .wrap-list {
  width: 575px;
  padding: 0.1rem;
  margin-right: 0.1rem;
  margin-bottom: 0.5rem;
  overflow: hidden;
  font-size: 0.3rem;
  border: 1px solid #6aafb7;
  background-color: #fff;
}
.wrap_list_new {
  background-color: #fff !important;
}
.wrap-4-wrap .wrap-list .enter-title {
  color: #3a3a3a;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.wrap-4-wrap .wrap-list .enter-name {
  /* width: 230px; */
  width: 100%;
  margin-left: 0.3rem;
  position: relative;
  color: #909090;
}
.enter_online_w {
  position: relative;
}
.wrap-4-wrap .wrap-list .enter-name .enter-name-list-title {
  font-size: 0.35rem;
  color: #6aafb7;
  font-weight: 600;
  height: 25px;
  width: 100%;
}
.wrap-4-wrap .wrap-list .enter-name .enter-name-list {
  margin-bottom: 0.1rem;
  font-size: 16px;
}
.wrap-4-wrap .wrap-list .enter-name .five-list {
  width: 50%;
  float: left;
}
.wrap-4-wrap .wrap-list .enter-detail {
  color: #909090;
  height: 250px;
  position: relative;
}
.wrap-4-wrap .wrap-list .enter-data {
  padding: 0.3125rem;
  padding-bottom: 0.5rem;
}
.wrap-4-wrap .wrap-list .enter-jobs {
  border: 0.0625rem solid #4fa9f6;
  width: 6rem;
  line-height: 3;
  margin: 0 auto;
  text-align: center;
  font-size: 0.3rem;
  font-weight: 700;
  color: #4fa9f6;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.wrap_list_new .enter-jobs {
  -webkit-box-shadow: 0 3px 3px #e5e5e5;
  box-shadow: 0 3px 3px #e5e5e5;
  background-color: #4fa9f6;
  color: #fff !important;
}
.wrap-4-wrap .wrap-list .enter-name .five-list {
  width: 1000%;
  float: left;
  text-align: left;
}
.red-header {
  z-index: 100;
}
.header {
  position: absolute;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 70px;
  font-size: 16px;
  font-family: PingFang SC, Helvetica, Arial, sans-serif;
  font-weight: 500;
  min-width: 1350px;
}
.header .navigation-bar {
  list-style-type: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  margin: 0 76px 0 0;
  padding: 0;
  min-width: 1080px;
  width: 100%;
}
.dark-theme .navigation-bar .active {
  color: #000;
}
.header .navigation-bar .active {
  margin-left: 58px;
}
.active {
  text-decoration: none;
}
.dark-theme .navigation-bar .navigation-item {
  position: relative;
}
.header .navigation-bar .navigation-item {
  cursor: pointer;
  margin: 0;
}
.dark-theme .navigation-bar .current-tab:before {
  visibility: visible;
  transform: translateX(0);
  opacity: 1;
}
.dark-theme .navigation-bar .navigation-item:before {
  position: absolute;
  bottom: -10px;
  visibility: hidden;
  content: "";
  width: 100%;
  height: 2px;
  background-color: hsla(0, 0%, 100%, 0.5);
  transform: translateX(-100%);
  border-radius: 2px;
  opacity: 0;
}
.el-header {
  padding: 0 !important;
}
.header .logo {
  height: 25px;
  margin-left: 91px;
  display: flex;
  align-items: center;
}
.header .logo .logo2 {
  cursor: pointer;
  margin-top: 1px;
  width: 150px;
  height: 62px;
  position: relative;
}
.header .logo .logo2 img {
  position: absolute;
  width: 100%;
  height: 100%;
}
.banner2 {
  width: 100%;
  height: 100%;
  background-position: 50%;
  background-repeat: no-repeat;
  background-size: cover;
  /* background-image: url(../../assets/banner2.png); */
  /* box-shadow: 0 16px 36px 4px rgba(255, 255, 255, .7); */
}
.el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #6aafb7 !important;
}
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li:hover {
  color: #6aafb7 !important;
}
.el-pagination.is-background .el-pager li:not(.disabled).active:hover {
  color: #fff !important;
}
.outline {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding-top: 1rem;
}
.item-wrapper {
  width: 940px;
  height: 198px;
  flex-direction: row;
  background-color: #fff;
  margin: 0 0 58px;
  cursor: pointer;
}
.item-wrapper,
.outline {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.item-wrapper .image-wrapper {
  height: 100%;
}
.item-wrapper .image-wrapper .image {
  width: 310px;
  height: 100%;
  object-fit: cover;
}
.item-wrapper .item {
  margin: 0 0 0 36px;
  padding-right: 30px;
  height: 189px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}
.item-wrapper .item .title-wrapper {
  margin: 10px 0 0;
  font-size: 20px;
  color: #000;
}
.item-wrapper .item .content {
  color: #666;
  line-height: 24px;
  width: 581px;
  /* height: 48px; */
  overflow: hidden;
  text-align: left;
  font-size: 15px;
  margin-top: 0.3rem;
}
.foot {
  margin-top: 20px;
  height: 288px;
  background-image: url(../../assets/footer.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  text-align: center;
  font-size: 12px;
  color: #000;
  padding: 15px;
  font-size: 16px;
  /* background-color: rgb(243, 243, 243); */
}
.foot p {
  line-height: 25px;
}
.el-footer {
  padding: 0 !important;
}
.el-container {
  background-image: url(../../assets/back1.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-color: rgb(243, 243, 243);
}
.cardBox {
  display: grid;
  grid-template-columns: repeat(2, 500px);
  grid-template-rows: repeat(1, 250px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 120px;
}
.cardBox2 {
  display: grid;
  grid-template-columns: repeat(2, 550px);
  grid-template-rows: repeat(1, 308px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.cardBox3 {
  display: grid;
  grid-template-columns: repeat(1, 500px);
  grid-template-rows: repeat(1, 300px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 120px;
}
.cardBox4 {
  display: grid;
  grid-template-columns: repeat(1, 500px);
  grid-template-rows: repeat(1, 200px);
  grid-row-gap: 100px;
  grid-column-gap: 100px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding-bottom: 60px;
}
.cardBox .box-card {
  max-width: 500px;
  margin: 0 auto;
  padding-top: 22px;
}
.box-card {
  width: 480px;
}
.text {
  font-size: 16px;
  text-align: left;
  text-indent: 30px;
  line-height: 28px;
}
.text2 {
  font-size: 16px;
  text-align: left;
  line-height: 28px;
}
.item {
  margin-bottom: 18px;
}
.main2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  /* margin: 60px auto; */
}
.main2 .section {
  display: flex;
  flex-direction: column;
  width: 1200px;
}
.web .list2 {
  display: flex;
  flex-direction: column;
}
.web .list2 ul {
  display: flex;
  flex-wrap: wrap;
}
.line2 {
  width: 100%;
  height: 1px;
  /* border-top: 1px solid #FDC236; */
  text-align: center;
  margin: 50px 0px;
  /* margin-top: 50px; */
  display: none;
}
.line2 span {
  position: relative;
  top: -12px;
  /* background: #F2FBF6; */
  padding: 0 10px;
  font-size: 20px;
  font-weight: 800;
  margin: 0 auto;
}
.web .list2 li {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 250px;
  padding: 10px 20px;
  border-radius: 10px;
  margin-right: 24px;
  margin-bottom: 24px;
  background-color: #fff;
}
.web .list2 li .firm {
  display: flex;
  flex-direction: column;
}
.web .list2 li .firm a {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px 0 20px;
}
.web .list2 li .firm a:hover {
  cursor:pointer
}
.web .list2 li .firm a p {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.web .list2 li .firm a p b {
  margin: 20px 0 12px;
  max-width: 242px;
  font-size: 16px;
  color: #333;
  line-height: 18px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.web .list2 li .firm a p span {
  font-size: 14px;
  color: #999;
  line-height: 14px;
}
.jobs2 {
  text-indent: 32px;
  font-size: 16px;
  line-height: 25px;
  /* display: flex;
  flex-direction: column; */
  height: 70px;
  display:-webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  text-overflow: ellipsis;
}
.jobs{
  display: flex;
  flex-direction: column;
  min-height: 90px;
}
.web .list2 li .jobs a {
  display: flex;
  justify-content: space-between;
  height: 30px;
  padding: 0 5px;
  border-radius: 5px;
  font-size: 15px;
  line-height: 30px;
}
.web .list2 li .jobs a span {
  max-width: 250px;
  color: #333;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.web .list2 li .btns {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 20px 0;
}
.web .list2 li .btns a {
  display: flex;
  padding-right: 15px;
  /* background: url(../img/more_hover.png) no-repeat right; */
  font-size: 13px;
  color: #888;
  line-height: 13px;
}
.web .list2 li .btns a {
  cursor:pointer
}
.tableWidth {
  width: 1200px;
  margin: 0 auto;
}
.box-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: normal;
  margin-left: 55px;
}
.sch_logo{
  padding-top: 30px;
  /* width: 100%;
  height: 100%; */
}
.image-slot{
  height: 100px;
}
.sch_logo img{
  width: 80%;
  /* height: 100%; */
}
@media all and (max-width: 767px) {
  .web .list2 li {
    width: 350px;
  }
  .main2 .section {
    width: 800px;
  }
  .tableWidth {
    width: 600px;
  }
  .cardBox {
    display: grid;
    grid-template-columns: repeat(2, 400px);
    grid-template-rows: repeat(1, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 50px;
    justify-content: center;
    padding-bottom: 120px;
  }
  .cardBox .box-card {
    max-width: 400px;
    margin: 0 auto;
    padding-top: 22px;
  }
  .cardBox2 {
    display: grid;
    grid-template-columns: repeat(1, 550px);
    grid-template-rows: repeat(1, 308px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .el-header {
    height: 395px !important;
  }
  .navigation ul#nav1 li a {
    padding: 0 10px;
  }
  .videoBox {
    display: grid;
    grid-template-columns: repeat(2, 350px);
    grid-template-rows: repeat(9, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    justify-content: center;
    padding-bottom: 120px;
  }
}
@media all and (min-width: 768px) and (max-width: 1170px) {
  .box-wrap {
    margin-left: 20px;
  }
  .web .list2 li {
    width: 350px;
  }
  .main2 .section {
    width: 800px;
  }
  .tableWidth {
    width: 900px;
  }
  .cardBox {
    display: grid;
    grid-template-columns: repeat(2, 400px);
    grid-template-rows: repeat(1, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 50px;
    justify-content: center;
    padding-bottom: 120px;
  }
  .cardBox .box-card {
    max-width: 400px;
    margin: 0 auto;
    padding-top: 22px;
  }
  .cardBox2 {
    display: grid;
    grid-template-columns: repeat(1, 550px);
    grid-template-rows: repeat(1, 308px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
  }
  .videoBox {
    display: grid;
    grid-template-columns: repeat(2, 350px);
    grid-template-rows: repeat(9, 250px);
    grid-row-gap: 100px;
    grid-column-gap: 100px;
    justify-content: center;
    padding-bottom: 120px;
  }
  .el-header {
    height: 395px !important;
  }
  .navigation ul#nav1 li a {
    padding: 0 30px;
  }
}

@media all and (min-width: 1171px) and (max-width: 1570px) {
  .box-wrap {
    margin-left: 0px;
  }
  .main2 .section {
    width: 1100px;
  }
  .tableWidth {
    width: 1000px;
  }
  .navigation ul#nav1 li a {
    padding: 0 80px;
  }
  .el-header {
    height: 500px !important;
  }
}
@media all and (min-width: 1571px) and (max-width: 1990px) {
  .navigation ul#nav1 li a {
    padding: 0 80px;
  }
  .el-header {
    height: 610px !important;
  }
}
@media all and (min-width: 1991px) and (max-width: 2080px) {
  .el-header {
    height: 650px !important;
  }
}
</style>
